import dayjs from "dayjs";
import { type ReactNode } from "react";
import { useIntl } from "react-intl";

import { FlightArrow } from "./FlightArrow";

type FlightTimeInfoProps = {
  date: string;
  time: string;
  code: string;
};

function FlightTimeInfo({ date, time, code }: FlightTimeInfoProps) {
  return (
    <div className="flex shrink-0 flex-col first:text-start last:text-end">
      <span className="text-sm whitespace-nowrap text-text-tertiary">
        {dayjs(date).format("MMMM DD")}
      </span>
      <h3 className="text-xl font-semibold text-text-title">
        {time.slice(0, 5)}
      </h3>
      <span className="text-sm text-text-tertiary">{code}</span>
    </div>
  );
}

type FlightOverallTimeProps = {
  stops: number;
  overallTime: string | null;
};

export const FlightOverallTime = ({
  overallTime,
  stops,
}: FlightOverallTimeProps) => {
  const intl = useIntl();

  return (
    <div className="flex flex-col items-center gap-0.5">
      <FlightArrow overallTime={overallTime} />
      <span className="text-sm text-text-tertiary">
        {stops
          ? `${stops} ${stops === 1 ? intl.formatMessage({ defaultMessage: "Stop", description: "Generic stop / layover label on a flight card" }) : intl.formatMessage({ defaultMessage: "Stops", description: "Generic stops / layovers label on a flight card" })}`
          : intl.formatMessage({
              defaultMessage: "Direct",
              description:
                "Direct flight label indicating no stops or layovers",
            })}
      </span>
    </div>
  );
};

export type FlightInfoProps = {
  origin: FlightTimeInfoProps;
  destination: FlightTimeInfoProps;
  children: ReactNode;
};

export function FlightInfo({ origin, destination, children }: FlightInfoProps) {
  return (
    <div className="flex w-full justify-between gap-6">
      <FlightTimeInfo {...origin} />

      <div className="grow pt-5">{children}</div>

      <FlightTimeInfo {...destination} />
    </div>
  );
}
